var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Azure/Custom Role") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "22.6227874%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3CF7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC87F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.8750714,6.80585921 C14.8750714,4.36761665 13.1844064,2.28320312 11.0578833,1.40820312 L9.62507096,3.88828158 L9.62507096,0.486171842 C9.62507096,0.216289163 9.4090555,0 9.13835254,0 L6.61178979,0 C6.34108642,0 6.12507096,0.216289163 6.12507096,0.486171842 L6.12507096,3.88773417 L4.69225862,1.4090234 C2.56573507,2.28320312 0.875070957,4.36679721 0.875070957,6.80585921 L0.87479767,8.75 L14.8747977,8.75 L14.8750714,6.80585921 L14.8750714,6.80585921 Z M15.7145248,9.89023471 C15.6461655,9.72890592 15.487572,9.625 15.3125714,9.625 L0.437571374,9.625 C0.263254968,9.625 0.105071274,9.7292347 0.03589162,9.88903141 C-0.0333155714,10.0496759 -0.000858636971,10.2360237 0.119618086,10.3631719 C0.192325024,10.4398434 1.96936795,12.25 7.85046217,12.25 C13.7315564,12.25 15.5094467,10.4401171 15.6051498,10.3632812 C15.7500714,10.2347653 15.7828842,10.0488281 15.7145248,9.89023471 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.9762325%",
    y1: "7.4114724%",
    x2: "37.1841038%",
    y2: "103.76182%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0669BC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.7237125%",
    y1: "52.3127289%",
    x2: "52.6927812%",
    y2: "54.8636556%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.3,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.2,
    offset: "7.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.1,
    offset: "32.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.05,
    offset: "62.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.2725685%",
    y1: "4.60005789%",
    x2: "62.4796378%",
    y2: "99.9794963%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2892DF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Azure/Custom-Role",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#222945",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uF807",
    transform: "translate(9.1249, 10.125)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#3267D6",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icons/18px/Amazon/Color",
    transform: "translate(22.2547, 22.5386)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "azure",
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.14851413,0.000107304529 L5.94320907,0.000107304529 L3.04204138,8.59380512 C2.98090095,8.77487422 2.81106292,8.89683312 2.61990699,8.89683312 L0.444943546,8.89683312 C0.301643642,8.89683312 0.167108917,8.82785723 0.0835239203,8.71148873 C-6.10768296e-05,8.59512022 -0.0224617556,8.44562453 0.0233458143,8.30987734 L2.72627241,0.303135295 C2.78738848,0.121986417 2.95729037,0 3.14851413,0 L3.14851413,0.000107304529 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20961224,5.76418457 L2.77789881,5.76418457 C2.69358223,5.76409147 2.61779822,5.8155943 2.58686426,5.8940118 C2.5559303,5.97242931 2.57614911,6.06178415 2.63783134,6.11925538 L5.48554799,8.77654474 C5.56845912,8.85386722 5.67762878,8.89683312 5.79101315,8.89683312 L8.30042123,8.89683312 L7.20961224,5.76418457 Z",
    id: "Path",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14851413,0.00010402031 C2.95501254,-0.000635074497 2.78352507,0.124545964 2.72530643,0.309037044 L0.0266730877,8.30258063 C-0.0222326534,8.43886588 -0.0016364072,8.5904278 0.0818658777,8.7087287 C0.165368163,8.82702959 0.301298125,8.89722435 0.446124191,8.89683474 L2.67722196,8.89683474 C2.84639467,8.86661435 2.98621907,8.74773187 3.04322203,8.58564998 L3.58138166,7.00001095 L5.503687,8.79253311 C5.58424228,8.85914778 5.68529465,8.89598135 5.7898325,8.89683474 L8.28990276,8.89683474 L7.19340519,5.76418469 L3.99696883,5.76493582 L5.95329822,0.00010402031 L3.14851413,0.00010402031 Z",
    id: "Path",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71803443,0.302706077 C6.65700464,0.121849003 6.48735631,0.000107304529 6.2964367,0.000107304529 L3.18178686,0.000107304529 C3.37269584,0.000107304529 3.54232688,0.121869652 3.60338459,0.302706077 L6.30641852,8.30977004 C6.35226066,8.44554204 6.32988048,8.59507767 6.24629549,8.71148872 C6.16271049,8.82789977 6.02815526,8.89694042 5.88482079,8.89694042 L8.99957796,8.89694042 C9.1428935,8.89694042 9.27741671,8.82785091 9.36097663,8.71144515 C9.44453654,8.5950394 9.46690445,8.44552411 9.42106836,8.30977004 L6.71803443,0.302706077 Z",
    id: "Path",
    fill: "url(#linearGradient-5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleCustom);
export default __webpack_public_path__ + "static/media/role-custom.cb568e6380558aa12e52fcf6cb1d8f9e.svg";
export { ForwardRef as ReactComponent };